import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class ApiService {
    domain: string;
  constructor(protected http: HttpClient, protected authService: AuthenticationService) {
      this.domain = '/api';
  }

  getById(module: string, id: string) {
    // TODO: do something
      return this.http.get(this.domain + '/' + module + '/' + id);
      // return new Observable();
  }

  post(module: string, object: any) {
      return this.http.post(this.domain + '/' + module,  object);
    //   return new Observable();
  }

  put(module: string, id: string, object: any) {
      // console.log('calling http put with', object);
      return this.http.put(this.domain + '/' + module + '/' + id, object);
  }

  getAll(module: string) {
      // TODO: do something
      return this.http.get(this.domain + '/' + module);
  }

  getTags(module: string) {
      return this.http.get(this.domain + '/' + module + '/tags');
  }

  getTagged(module: string, tags: Array<string>) {
      const tagsParam = encodeURIComponent(tags.map(x => x.trim()).join(','));
      return this.http.get(this.domain + '/' + module + '/tagged/' + tagsParam);
  }

  deleteByID(module: string, id: number) {
      console.log('calling delete method with:');
      const url = this.domain + '/' + module + '/' + String(id);
      console.log(url);
      return this.http.delete(url);
    // TODO: do something
    //   return new Observable();
  }

  search(module: string, searchTerm: string) {
      console.log('api service called with searchTerm: ', searchTerm);
      return this.http.get(this.domain + '/' + module + '/search/' + searchTerm);
  }
}



// WEBPACK FOOTER //
// ./src/app/api.service.ts